import styled from "styled-components";

export const StyledWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 32px;
  right: 0;
  overflow: hidden;
`;

export const StyledHistoryLoaderWrapper = styled.div`
  position: relative;
`;
